var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isRichMode)?_c('NoteRich',{attrs:{"note-id":_vm.noteId}}):(_vm.isPlainMode)?_c('NotePlain',{attrs:{"note-id":_vm.noteId}}):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }